function ListeInterventions(){
    
    this.aInterventions = [];
    
    this.addIntervention = function(){

    }
    
    
    this.getIntervention = function(iId){
        for(i in this.aInterventions){
            if(this.aInterventions[i].iId == iId){
                return this.aInterventions[i];
            }
        }
    }
    
}

module.exports = ListeInterventions;